import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
//import Layout from '@/layout'
import { ProjectLayout, OfficeLayout } from '@/layout'
export const constantRoutes = [
    {
      path: '/login',
      component: () => import('@/views/UserLogin'),
      hidden: true,
      name: 'Login',
      meta: { title: '登录', icon: 'dashboard' }
    },
    {
      path: '/forgotPwd',
      component: () => import('@/views/ForgotPwd'),
      hidden: true,
      name: 'ForgotPwd',
      meta: { title: '忘记密码', icon: 'dashboard' }
    },
    {
      path: '/register',
      component: () => import('@/views/Register'),
      hidden: true,
      name: 'Register',
      meta: { title: '注册', icon: 'dashboard' }
    },
    {
      path: '/',
      redirect: '/console',
      component: ProjectLayout,
      type: 'project',
      children: [
      {
        path: '/console',
        name: 'console',
        component: () => import('@/views/Console'),
        meta: { title: '控制台', icon: 'dashboard'}
      }]
    },
    {
      path: '/oaconsole',
      component: OfficeLayout,
      children: [
      {
        path: '/oaconsole',
        name: 'oaconsole',
        component: () => import('@/views/OAConsole'),
        meta: { title: '控制台', icon: 'dashboard'}
      }]
    },

    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/apply/:defId?/:token?',
      component: () => import('@/views/Apply'),
      hidden: true,
      name: 'Apply',
      meta: { title: '发起审批', icon: 'dashboard' }
    },
    {
      path: '/applyDetail/:instanceId?/:token?',
      component: () => import('@/views/applyDetail'),
      hidden: true,
      name: 'applyDetail',
      meta: { title: '审批详情', icon: 'dashboard' }
    },
    {
      path: '/projects',
      component: ProjectLayout,
      type: 'project',
      children: [
        {
          path: 'type/all',
          name: 'Projects',
          component: () => import('@/views/Project'),
          meta: { title: '项目', icon: 'dashboard' }
        },
        {
        path: 'type/:key?',
        name: 'ProjectsList',
        hidden: true,
        component: () => import('@/views/Project'),
        meta: { title: '项目', icon: 'dashboard', activeMenu: '/projects/type/all'}
      },
      {
        path: '/template',
        name: 'Template',
        hidden: true,
        component: () => import('@/views/Template'),
        meta: { title: '模板', icon: 'dashboard', activeMenu: '/projects/type/all'}
      },
      {
        path: '/task/:id?/:menuKey?',
        hidden: true,
        name: 'Task',
        component: () => import('@/views/Task'),
        meta: { title: '工作项', icon: 'dashboard', activeMenu: '/projects/type/all'}
      },
      {
        path: '/file/:id?/:type?',
        hidden: true,
        name: 'File',
        component: () => import('@/views/File'),
        meta: { title: '文件管理', icon: 'dashboard', activeMenu: '/projects/type/all'}
      }
    ]
    },
    {
      path: '/team',
      component: ProjectLayout,
      type: 'project',
      children: [{
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team'),
        meta: { title: '团队', icon: 'dashboard' }
      }]
    },
    {
      path: '/daily',
      component: ProjectLayout,
      type: 'project',
      children: [{
        path: '/daily',
        name: 'Daily',
        component: () => import('@/views/Daily'),
        meta: { title: '日报', icon: 'dashboard' }
      },
      {
        path: '/teamdaily',
        name: 'TeamDaily',
        type: 'project',
        hidden: true,
        component: () => import('@/views/TeamDaily'),
        meta: { title: '团队日报', icon: 'dashboard' ,activeMenu: '/daily'}
      }
      ]
    },
    

    {
      path: '/dashboard',
      component: ProjectLayout,
      type: 'project',
      children: [
      {
        path: '/dashboard/:id?',
        name: 'Dashboard',
        hidden: true,
        component: () => import('@/views/Dashboard'),
        meta: { title: '总览', icon: 'dashboard' ,activeMenu: '/dashboard'}
      }]
    },
    {
      path: '/account',
      component: ProjectLayout,
      type: 'project',
      children: [{
        path: '/account',
        name: 'Account',
        component: () => import('@/views/Account'),
        meta: { title: '账户', icon: 'dashboard' }
      }]
    },
    {
      path: '/message',
      component: ProjectLayout,
      type: 'project',
      hidden: true,
      children: [{
        path: '/message',
        name: 'Message',
        component: () => import('@/views/Message'),
        meta: { title: '消息', icon: 'dashboard' }
      }]
    },
    {
      path: '/personnel',
      component: OfficeLayout,
      meta: { title: '员工管理'},
      children: [
        {
          path: 'staff',
          name: 'Staff',
          component: () => import('@/views/index/personnel/Staff'),
          meta: { title: '员工管理', icon: 'dashboard',activeMenu: '/personnel/staff'  }
        },
        {
          path: 'detail/:employeeId?',
          name: 'StaffDetail',
          hidden: true,
          component: () => import('@/views/index/personnel/Detail'),
          meta: { title: '员工详情', icon: 'dashboard',activeMenu: '/personnel/staff' }
        },
        {
          path: 'join',
          name: 'Join',
          hidden: true,
          component: () => import('@/views/index/personnel/Join'),
          meta: { title: '入职管理', icon: 'dashboard',activeMenu: '/personnel/staff'  }
        },
        {
          path: 'positive',
          name: 'Positive',
          hidden: true,
          component: () => import('@/views/index/personnel/Positive'),
          meta: { title: '转正管理', icon: 'dashboard',activeMenu: '/personnel/staff' }
        },
        {
          path: 'leave',
          name: 'Leave',
          hidden: true,
          component: () => import('@/views/index/personnel/Leave'),
          meta: { title: '离职管理', icon: 'dashboard',activeMenu: '/personnel/staff'  }
        },
        {
          path: 'change',
          name: 'Change',
          hidden: true,
          component: () => import('@/views/index/personnel/Change'),
          meta: { title: '异动记录', icon: 'dashboard',activeMenu: '/personnel/staff'  }
        },
        {
          path: 'contract',
          name: 'Contract',
          hidden: true,
          component: () => import('@/views/index/personnel/Contract'),
          meta: { title: '合同管理', icon: 'dashboard',activeMenu: '/personnel/staff'  }
        }
      ]
    },
    {
      path: '/organization',
      component: OfficeLayout,
      meta: { title: '组织管理'},
      children: [
        {
          path: 'department',
          name: 'Department',
          component: () => import('@/views/index/organization/Department'),
          meta: { title: '组织管理', icon: 'dashboard', activeMenu: '/organization/department' }
        },
        {
          path: 'position',
          name: 'Position',
          hidden: true,
          component: () => import('@/views/index/organization/Position'),
          meta: { title: '职位管理', icon: 'dashboard', activeMenu: '/organization/department' }
        },
        {
          path: 'rank',
          name: 'Rank',
          hidden: true,
          component: () => import('@/views/index/organization/Rank'),
          meta: { title: '职级管理', icon: 'dashboard', activeMenu: '/organization/department' }
        },
        {
          path: 'place',
          name: 'WorkPlace',
          hidden: true,
          component: () => import('@/views/index/organization/Place'),
          meta: { title: '工作地点', icon: 'dashboard', activeMenu: '/organization/department' }
        },
        {
          path: 'company',
          name: 'Company',
          hidden: true,
          component: () => import('@/views/index/organization/Company'),
          meta: { title: '合同公司', icon: 'dashboard', activeMenu: '/organization/department' }
        }
      ]
    },
    {
      path: '/attendance',
      component: OfficeLayout,
      meta: { title: '考勤管理'},
      children: [
        {
          path: 'schedule',
          name: 'Schedule',
          component: () => import('@/views/index/attendance/Schedule'),
          meta: { title: '考勤管理', icon: 'dashboard', activeMenu: '/attendance/schedule' }
        },
        {
          path: 'group',
          name: 'Group',
          hidden: true,
          component: () => import('@/views/index/attendance/Group'),
          meta: { title: '考勤组设置', icon: 'dashboard', activeMenu: '/attendance/schedule' }
        },
        {
          path: 'addGroup/:employeeId?',
          name: 'AddGroup',
          hidden: true,
          component: () => import('@/views/index/attendance/AddGroup'),
          meta: { title: '添加考勤组', icon: 'dashboard', activeMenu: '/attendance/schedule'}
        },
        {
          path: 'editGroup/:id?',
          name: 'EditGroup',
          hidden: true,
          component: () => import('@/views/index/attendance/EditGroup'),
          meta: { title: '编辑考勤组', icon: 'dashboard', activeMenu: '/attendance/schedule'}
        },
        {
          path: 'daily',
          name: 'Daily Statistics',
          hidden: true,
          component: () => import('@/views/index/attendance/Daily'),
          meta: { title: '每日统计', icon: 'dashboard', activeMenu: '/attendance/schedule' }
        },
        {
          path: 'month',
          name: 'Month Statistics',
          hidden: true,
          component: () => import('@/views/index/attendance/Month'),
          meta: { title: '月度统计', icon: 'dashboard', activeMenu: '/attendance/schedule' }
        },
        {
          path: 'sign',
          name: 'Sign',
          hidden: true,
          component: () => import('@/views/index/attendance/Sign'),
          meta: { title: '考勤记录', icon: 'dashboard', activeMenu: '/attendance/schedule' }
        }
      ]
    },
    {
      path: '/approval',
      component: OfficeLayout,
      meta: { title: '审批管理'},
      children: [
        {
          path: 'category',
          name: 'Category',
          component: () => import('@/views/index/approval/Category'),
          meta: { title: '审批管理', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'list',
          name: 'ApprovalList',
          hidden: true,
          component: () => import('@/views/index/approval/List'),
          meta: { title: '审批列表', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'editApproval/:defId?',
          name: 'ApprovalDeatail',
          hidden: true,
          component: () => import('@/views/index/approval/EditApproval'),
          meta: { title: '审批详情', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'custom',
          name: 'Custom Form',
          hidden: true,
          component: () => import('@/views/index/approval/CustomForm'),
          meta: { title: '自定义审批', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'add',
          name: 'Add Approval',
          hidden: true,
          component: () => import('@/views/index/approval/Add'),
          meta: { title: '发起申请', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'addApproval/:defId?',
          name: 'AddApproval',
          hidden: true,
          component: () => import('@/views/index/approval/AddApproval'),
          meta: { title: '添加审批', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'wait',
          name: 'Wait',
          hidden: true,
          component: () => import('@/views/index/approval/Wait'),
          meta: { title: '待办', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'done',
          name: 'Done',
          hidden: true,
          component: () => import('@/views/index/approval/Done'),
          meta: { title: '已办', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'carbon',
          name: 'Copy Me',
          hidden: true,
          component: () => import('@/views/index/approval/Carbon'),
          meta: { title: '抄送我', icon: 'dashboard', activeMenu: '/approval/category' }
        },
        {
          path: 'have',
          name: 'Have',
          hidden: true,
          component: () => import('@/views/index/approval/Have'),
          meta: { title: '已发起', icon: 'dashboard', activeMenu: '/approval/category' }
        }
      ]
    },{
      path: '/meeting',
      component: OfficeLayout,
      meta: { title: '会议预定'},
      children: [
        {
          path: 'device',
          name: 'DeviceList',
          component: () => import('@/views/index/meeting/Device'),
          meta: { title: '会议预定', icon: 'dashboard', activeMenu: '/meeting/device' }
        },
        {
          path: 'list',
          name: 'List',
          hidden: true,
          component: () => import('@/views/index/meeting/List'),
          meta: { title: '会议室管理', icon: 'dashboard', activeMenu: '/meeting/device' }
        },
        {
          path: 'reservation',
          name: 'reservation meeting',
          hidden: true,
          component: () => import('@/views/index/meeting/Reservation'),
          meta: { title: '预约会议室', icon: 'dashboard', activeMenu: '/meeting/device' }
        },
        {
          path: 'record',
          name: 'meettingRecord',
          hidden: true,
          component: () => import('@/views/index/meeting/Record'),
          meta: { title: '预约记录', icon: 'dashboard', activeMenu: '/meeting/device' }
        }
      ]
    },
    {
      path: '/work',
      component: OfficeLayout,
      meta: { title: '汇报管理'},
      children: [{
        path: 'daily',
        name: 'work daily',
        component: () => import('@/views/index/work/Daily'),
        meta: { title: '汇报管理', icon: 'dashboard', activeMenu: '/work/daily' }
      },
      {
        path: 'week',
        name: 'work week',
        hidden: true,
        component: () => import('@/views/index/work/Week'),
        meta: { title: '工作周报', icon: 'dashboard', activeMenu: '/work/daily' }
      },
      {
        path: 'month',
        name: 'work month',
        hidden: true,
        component: () => import('@/views/index/work/Month'),
        meta: { title: '工作月报', icon: 'dashboard', activeMenu: '/work/daily' }
      }]
    },
    {
      path: '/OKR',
      component: OfficeLayout,
      meta: { title: 'OKR管理'},
      children: [{
        path: 'list',
        name: 'OKR Manage',
        component: () => import('@/views/index/OKR/List'),
        meta: { title: 'OKR管理', icon: 'dashboard' }
      }]
    },
]

const createRouter = () => new Router({
    //mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })
  
  const router = createRouter()
  
  // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
  export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
  }
  
  export default router